import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function SRERoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month SRE Career Roadmap`}
      subtitle="Site Reliability Engineering Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-sre-roadmap.pdf"
      roleKey={roleKey || "sre"}
    />
  );
}

